<template>
  <div class="width-100p">
    <v-dialog
      v-model="dialog"
      content-class="crud-dialog"
      persistent
      max-width="400px"
    >
      <template #activator="{ on }">
        <v-btn depressed large block color="white" class="ma-0" v-on="on">
          Mark as deceased
        </v-btn>
      </template>

      <v-card class="crud-card">
        <v-card-title class="crud-card-title">
          <v-row no-gutters>
            <v-col cols="11">
              <h2 class="text-h5">Mark as Deceased</h2>
            </v-col>
            <v-col cols="1">
              <v-icon
                class="modal-close"
                color="black"
                @click.stop="closeDialog"
                >{{ icons.mdiClose }}</v-icon
              >
            </v-col>
          </v-row>
        </v-card-title>

        <v-divider />

        <v-card-text class="crud-card-text">
          <p>
            Please enter the date of death for <b>{{ testatorName }}</b>
          </p>
          <input
            id="date_deceased_input"
            type="date"
            v-model="deceased_date"
            :max="new Date().toISOString().split('T')[0]"
            required
          />
        </v-card-text>

        <v-card-text class="crud-card-text">
          <v-select
            v-model="deceased_status"
            :items="[
              'Deceased – Independent Executor',
              'Deceased – Under R250 000 Estate',
              'Deceased – Tracing (awaiting contact)',
              'Deceased – Old Mutual Will Executors',
            ]"
            label="Deceased Status"
          />
        </v-card-text>

        <v-card-actions class="crud-card-actions">
          <v-row no-gutters>
            <v-col cols="12">
              <v-btn
                rounded
                depressed
                :loading="buttonLoading"
                color="primary"
                class="left-edit-btn"
                @click="markAsDeceased()"
              >
                <span>Mark as deceased</span>
                <v-icon small>{{ icons.mdiArrowRight }}</v-icon>
              </v-btn>

              <v-btn
                class="right-edit-btn"
                rounded
                depressed
                outlined
                color="grey.darken1"
                @click="closeDialog()"
              >
                Cancel
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ErrorSnackbar v-model="showError" />
  </div>
</template>

<script>
  import ErrorSnackbar from '../../common/ErrorSnackbar.vue';
  import { formHelperMixin } from '../../../mixins/form-helper-mixin';
  import { MARK_TESTATOR_DECEASED_MUTATION } from '../../../constants/graphql/testators';

  export default {
    name: 'deceaseTestator',
    components: {
      ErrorSnackbar,
    },
    mixins: [formHelperMixin],
    props: {
      testator: {
        required: true,
        type: Object,
      },
      referrerRoute: {
        type: String,
        default: 'AdminPage',
      },
      referrerId: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        dialog: false,
        deceased_date: null,
        deceased_status: null,
        successMessage: null,
      };
    },
    computed: {
      testatorName() {
        return this.testator.fullName
          ? this.testator.fullName
          : this.testator.email;
      },
      isAdmin() {
        return this.$store.getters.isAdmin;
      },
    },
    methods: {
      markAsDeceased() {
        const id = this.testator.id;
        if (this.deceased_date == null) {
          document
            .getElementById('date_deceased_input')
            .classList.add('error--text');
          return;
        }

        const testatorInputDetails = {
          deceasedDate: this.deceased_date,
          deceasedStatus: this.deceased_status,
        };
        this.$apollo
          .mutate({
            mutation: MARK_TESTATOR_DECEASED_MUTATION,
            variables: {
              id,
              testatorInputDetails,
            },
          })
          .then(response => {
            if (response.data.deceaseTestator.success) {
              this.successMessage = 'User successfully marked as deceased';
              this.redirect();
            } else {
              this.displayErrorAndCloseDialog();
            }
          })
          .catch(error => {
            this.displayErrorAndCloseDialog();
            throw error;
          });
      },
      redirect() {
        this.$router.push({
          name: this.referrerRoute,
          params: { id: this.referrerId, successMessage: this.successMessage },
        });
      },
      closeDialog() {
        this.dialog = false;
        this.buttonLoading = false;
      },
    },
  };
</script>
